import Vue from 'vue'
import Vuex from 'vuex'
import base from './modules/base'
import study from './modules/study'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    base,
    study
  },
  actions,
  getters
})
